import StellarSdk from '@xdbchain/js-stellar-sdk';
import axios from 'axios';
import Config from '../Config';

class Network {


    server = new StellarSdk.Server((new Config()).conf.server);

    constructor() {

        this.config = new Config();

        //console.log(this.config);

        this.getTransactionOperationsPromise = this.getTransactionOperationsPromise.bind(this);
        this.getTransactionPromise = this.getTransactionPromise.bind(this);
        this.getAccountTransactions = this.getAccountTransactions.bind(this);
        this.getTransaction = this.getTransaction.bind(this);
        this.getOperations = this.getOperations.bind(this);
        this.getAccount = this.getAccount.bind(this);
        this.getLedgerTransactions = this.getLedgerTransactions.bind(this);
        this.getLedger = this.getLedger.bind(this);
        this.getLastLedgers = this.getLastLedgers.bind(this); 
        this.getLiquidityPool = this.getLiquidityPool.bind(this);
    }

    getTransactionOperationsPromise(id){
        return this.server.operations().forTransaction(id).order("desc").limit(100).call();
    }

    getTransactionPromise(id){
        return this.server.transactions().transaction(id).call();
    }

    getTransaction(id, callback, error){
        this.server.transactions().transaction(id).call()
        .then(callback).catch(error);
    }

    getOperations(callback, error){
        this.server.operations().order("desc").limit(15).call()
        .then(callback).catch(error);
    }

    getAccountTransactions(id, callback, error){
        this.server.transactions().forAccount(id).order("desc").limit(100).call()
        .then(callback).catch(error);
    }

    getLedgerTransactions(id, count, callback, error){
        this.server.transactions().forLedger(id).order("desc").limit(count).call()
        .then(callback).catch(error);
    }

    getLedger(id, callback, error){
        this.server.ledgers().ledger(id).call()
        .then(callback).catch(error);
    }

    getAccount(id, callback, error){
        this.server.accounts().accountId(id).call()
        .then(callback).catch(error);
    }

    getLastLedgers(callback, error){
        this.server.ledgers().limit(200).order("desc").call()
        .then(callback).catch(error);
    }

    getHistory(callback, error){
        axios.get(this.config.conf.stats, {timeout: 2500}).then(data=>{callback(data.data)}).catch(err=>{console.log("test");console.log(err);callback(null);});
    }

    getLiquidityPool(id, callback, error){
        this.server.liquidityPools().liquidityPoolId(id).call()
        .then(callback).catch(error);
    }
}

export const network = new Network();

export default Network



// WEBPACK FOOTER //
// ./src/components/Network.js